import { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import Loader from "react-loader-spinner";


export interface TableProps {
    columns?: any;
    data?: any;
}


export default function TableCustom({
    columns,
    data,
}: TableProps) {
    const [loading, setLoading] = useState(true)
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#d24e29',
                color: 'white'
            }
        }
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timeout);
    }, [])

    return (
        <DataTable
            columns={columns}
            data={data}
            pagination
            customStyles={customStyles}
            progressPending={loading}
            progressComponent={
                <div className='flex justify-center h-56 items-center'>
                    <Loader
                        type="Circles"
                        color="#d24e29"
                        height={25}
                        width={25}
                    />
                </div>
            }
        />
    )
}
